/**
 * This is a global vue mixin for miscellaneous methods.
 */

export default Vue.mixin({
	methods: {
		/**
		 * Generate unique id.
		 */
		_guid() {
			let component_name = _.kebabCase(this.constructor.name);

			if (component_name.substring(0, 3) === 'vm-') {
				component_name = component_name.substring(3);
			}

			return component_name + '-' + this._uid;
		},

		/**
		 * Determine if a file is an image.
		 *
		 * @param {string} filename
		 */
		isImage(filename) {
			return isImageType(filename);
		},

		/**
		 * Determine the file icon class for previews.
		 * 
		 * @param {string} filename
		 * @param {bool} preview_class
		 */
		fileIconClass(filename, preview_class = true) {
			let classes = [];
			
			if (preview_class) {
				classes.push('preview');
			}
			
			classes.push(fileIcon(filename));
			
			return classes;
		},

		/**
		 * Move cursor to end of a div.
		 *
		 * @param div
		 */
		moveCursorToEnd(div) {
			let range, sel;
			if (document.createRange) { // Firefox, Chrome, Opera, Safari, IE 9+
				// Create a range (a range is like a selection but invisible)
				range = document.createRange();

				// Select the entire contents of the element with the range
				range.selectNodeContents(div);

				// Collapse the range to the end point (false means collapse to end rather than the start)
				range.collapse(false);

				// Get the selection object (allows you to change selection)
				sel = window.getSelection();

				// Remove any selections already made
				sel.removeAllRanges();

				// Make the range you have just created the visible selection.
				sel.addRange(range);
			} else if (document.selection) { // IE 8 & lower
				// Create a range (a range is like a selection but invisible)
				range = document.body.createTextRange();

				// Select the entire contents of the element with the range
				range.moveToElementText(div);

				// Collapse the range to the end point (false means collapse to end rather than the start)
				range.collapse(false);

				// Select the range (make it the visible selection)
				range.select();
			}
		},

		/**
		 * Determine the correct url for something.
		 * 
		 * @param {string} endoint
		 */
		prefixUrl(endpoint) {
			if (_.isFunction(prefix_url)) {
				return prefix_url(endpoint);
			}
	
			return endpoint;
		},

		/**
		 * Select all text in a div.
		 *
		 * @param div
		 */
		selectAllText(div) {
			let sel, range;
			if (window.getSelection && document.createRange) {
				range = document.createRange();
				range.selectNodeContents(div);
				sel = window.getSelection();
				sel.removeAllRanges();
				sel.addRange(range);
			} else if (document.body.createTextRange) {
				range = document.body.createTextRange();
				range.moveToElementText(div);
				range.select();
			}
		},

		/**
		 * Determine if two dates are equal.
		 *
		 * @param date1
		 * @param date2
		 *
		 * @return bool
		 */
		equalDates(date1, date2) {
			return moment(date1).isSame(date2);
		},

        /**
         * Post an ajax request.
         *
         * @param {string} endPoint
         * @param {object} payload
         * @param {object} config
         */
        postRequest(endPoint, payload = {}, config = {}) {
            return this.submitRequest('post', endPoint, payload, config);
        },

        /**
         * Submit a GET ajax request.
         *
         * @param {string} endPoint
         * @param {object} payload
         * @param {object} config
         */
        getRequest(endPoint, payload = {}, config = {}) {
            payload = {
                params: payload
            };
            return this.submitRequest('get', endPoint, payload, config);
        },

        /**
         * Submit an ajax request.
         *
         * @param {string} requestType
         * @param {string} endPoint
         * @param {object} payload
         * @param {object} config
         */
        submitRequest(requestType, endPoint, payload = {}, config = {}) {
            return new Promise((resolve, reject) => {
                axios[requestType](endPoint, payload, config)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
	}
});